<form [formGroup]="searchForm" class="transactions__filter">
  <air-search-bar-input
    (searchInput)="input()"
    (searchKeyDown)="inputKeyDown($event)"
    (searchClose)="inputCancel()"
    (searchCancel)="inputCancel()"
    [static]="true"
    [placeholder]="placeholder"
  >
  </air-search-bar-input>

  <ng-container *ngIf="filteredItems?.length; else noResults">
    <div class="transactions-filter__search">
      <input type="checkbox" [id]="id" [checked]="isCheckedAll" (change)="toggleSelectAll()" /><label [for]="id">
        {{ selectAllLabel }}
      </label>
    </div>
    <div class="transactions-filter__items">
      <ng-container *ngFor="let item of filteredItems">
        <input type="checkbox" [id]="item.value" [checked]="item.checked" (change)="toggleSelect(item)" /><label [for]="item.value">
          {{ item.value }}
        </label>
      </ng-container>
    </div>
  </ng-container>
</form>

<ng-template #noResults>
  <p class="transactions-filter__no-results">{{ "transactions.label.no_items_available" | translate }}</p>
</ng-template>
